'use client';
import { FC, useCallback } from 'react';
import { useFm } from '@web3/base-hooks';
import { CopyIcon } from '@bfe/moly-icons';
import copy from 'copy-text-to-clipboard';
import { isInApp } from '@web3/base-utils';

import styles from './index.module.scss';

import cls from 'classnames';
import { useToast } from '@bfe/moly';

interface IProps {
  address: string;
  isOpenWindow?: boolean;
  className?: string;
  headClip?: number;
  tailClip?: number;
}

export const Address: FC<IProps> = (props) => {
  const {
    address,
    className,
    isOpenWindow = true,
    headClip = 6,
    tailClip = 4,
  } = props;
  const fm = useFm();
  const filledAddress = String(address);
  const { toast, EToastType } = useToast();
  const onCopy = useCallback(() => {
    try {
      // copy(filledAddress);
      toast({
        iconType: EToastType.SUCCESS,
        title: fm('copySuccess'),
      });
    } catch (err) {
      // eslint-disable-next-line
      console.error('onCopy', err);
    }
  }, []);

  const addr = `${filledAddress.slice(0, headClip)}...${filledAddress.slice(-tailClip)}`;

  return (
    <div className={cls(styles.address, className)}>
      {isInApp || !isOpenWindow ? (
        <>{addr}</>
      ) : (
        <a href={'https://mempool.space/tx/' + address} target="_blank">
          {addr}
        </a>
      )}

      <CopyIcon onClick={onCopy} className={styles.copyIcon} />
    </div>
  );
};
